import React from 'react';
import ReactDOM from 'react-dom/client';
import { setAccent } from '@theonefamily/ui';
import App from './App';
import './index.css';

// Security accent: indigo #4f46e5
setAccent('#4f46e5');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
